import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import css from "../landing_layout.module.scss";
import { Logo } from "./logo";

export const Header = ({ style }: { style?: React.CSSProperties }) => {
  const { data: currentAccount } = useCurrentAccount();
  const { t } = useTranslation("translation", { keyPrefix: "navBar" });

  return (
    <div className={css.header} data-qa-id="LandingLayout.header" style={style}>
      <Link
        className={css.logo}
        to="/"
        data-qa-id="LandingLayout.headerLogoLink"
        aria-label={t("logoHomeLink")}
      >
        <Logo height={22} width={96} />
      </Link>
      <span data-qa-id="LandingLayout.contactInfo">{currentAccount.customization?.contactInfo}</span>
    </div>
  );
};
